// extracted by mini-css-extract-plugin
export var active = "_94-a";
export var activeIndicator = "_94-8";
export var animate = "_94-9";
export var disabled = "_94-b";
export var fullWidth = "_94-2";
export var lg = "_94-7";
export var md = "_94-6";
export var redoButtonTabGroup = "_94-0";
export var sm = "_94-5";
export var tabButton = "_94-3";
export var tabButtonsContainer = "_94-1";
export var xs = "_94-4";